module.exports = __webpack_public_path__ + "static/media/survey-on-phone-English.7f0178c1.png";